(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  function setMainImg(url) {
    var m = document.querySelector('[data-pdp-main] img');
    if (!m || !url) return;
    m.removeAttribute('srcset');
    m.removeAttribute('sizes');
    m.src = url;
  }

  /* ---------- Mobile nav ---------- */
  var navToggle = $('[data-nav-toggle]');
  if (navToggle) navToggle.addEventListener('click', function () {
    var m = $('[data-nav-menu]'); if (m) m.classList.toggle('open');
  });

  /* ---------- Size chart modal ---------- */
  function openSize(e) { if (e) e.preventDefault(); var s = $('[data-size-scrim]'); if (s) s.classList.add('open'); }
  function closeSize() { var s = $('[data-size-scrim]'); if (s) s.classList.remove('open'); }
  $$('[data-size-open]').forEach(function (b) { b.addEventListener('click', openSize); });
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-size-open]')) openSize(e);
    if (e.target.matches('[data-size-close]') || e.target.matches('[data-size-scrim]')) closeSize();
  });

  /* ---------- Cart drawer ---------- */
  function openCart(e) { if (e) e.preventDefault(); $('[data-cart-scrim]').classList.add('open'); $('[data-cart-drawer]').classList.add('open'); refreshCart(); }
  function closeCart() { $('[data-cart-scrim]').classList.remove('open'); $('[data-cart-drawer]').classList.remove('open'); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.matches('[data-cart-close]') || e.target.matches('[data-cart-scrim]')) closeCart();
  });

  function renderCart(cart) {
    var items = $('[data-cart-items]'); if (!items) return;
    $('[data-cart-count]') && ($('[data-cart-count]').textContent = cart.item_count);
    $('[data-cart-subtotal]') && ($('[data-cart-subtotal]').textContent = money(cart.total_price));
    // progress: count belts toward 3-for-2
    var belts = 0;
    cart.items.forEach(function (i) { if ((i.product_type || '').toLowerCase().indexOf('belt') > -1 && i.handle !== 'the-3-pack') belts += i.quantity; });
    var pct = Math.min(belts / 3, 1) * 100;
    $('[data-prog-bar]') && ($('[data-prog-bar]').style.width = pct + '%');
    var pt = $('[data-prog-text]');
    if (pt) {
      if (belts === 0) pt.innerHTML = 'Add belts and the lowest-priced third is free.';
      else if (belts === 1) pt.innerHTML = 'Add <strong style="color:#A9683C">2 more belts</strong> &mdash; the third is free.';
      else if (belts === 2) pt.innerHTML = 'Add <strong style="color:#A9683C">1 more belt</strong> &mdash; it&rsquo;s free.';
      else pt.innerHTML = '&#127881; Buy 2 Get 1 Free unlocked &mdash; cheapest belt is free at checkout.';
    }
    if (!cart.items.length) { items.innerHTML = '<div class="drawer-empty">Your bag is empty.</div>'; return; }
    items.innerHTML = cart.items.map(function (i) {
      return '<div class="ci">' +
        '<img src="' + (i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="">' +
        '<div style="flex-grow:1">' +
          '<div class="nm">' + i.product_title + '</div>' +
          '<div class="vt">' + (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '') + '</div>' +
          '<div style="display:flex;align-items:center;gap:10px;margin-top:6px">' +
            '<div class="qty" style="font-size:13px"><button data-dec="' + i.key + '" aria-label="Decrease">&minus;</button><span>' + i.quantity + '</span><button data-inc="' + i.key + '" aria-label="Increase">+</button></div>' +
          '</div>' +
        '</div>' +
        '<div class="price">' + money(i.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  function refreshCart() { fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }

  function changeQty(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-inc]'); var dec = e.target.closest('[data-dec]');
    if (inc || dec) {
      var key = (inc || dec).getAttribute(inc ? 'data-inc' : 'data-dec');
      var span = (inc || dec).parentNode.querySelector('span');
      var cur = parseInt(span.textContent, 10) || 1;
      changeQty(key, inc ? cur + 1 : Math.max(0, cur - 1));
    }
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[data-qty-val]');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] }) })
      .then(function (r) { return r.json(); }).then(function () { openCart(); });
  });

  /* ---------- PDP: qty stepper ---------- */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]'); var dn = e.target.closest('[data-qty-down]');
    if (!up && !dn) return;
    var box = (up || dn).closest('.qty'); var val = box.querySelector('[data-qty-val]');
    var n = parseInt(val.textContent, 10) || 1;
    val.textContent = up ? n + 1 : Math.max(1, n - 1);
  });

  /* ---------- PDP: variant selection ---------- */
  var vEl = $('[data-variants]');
  if (vEl) {
    var variants = JSON.parse(vEl.textContent || '[]');
    var selected = {};
    // init from first available variant
    var init = variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (init) (init.options || []).forEach(function (val, idx) { selected[idx] = val; });

    function media() { return $('[data-pdp-main] img'); }
    function update() {
      var match = variants.find(function (v) {
        return (v.options || []).every(function (val, idx) { return selected[idx] === val; });
      });
      $$('[data-opt-group]').forEach(function (g) {
        var gi = parseInt(g.getAttribute('data-opt-group'), 10);
        $$('.sw', g).forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-opt-value') === selected[gi]); });
      });
      if (match) {
        var idInput = $('[name="id"]'); if (idInput) idInput.value = match.id;
        var p = $('[data-pdp-price]'); if (p) p.textContent = money(match.price);
        var addBtn = $('[data-add-btn]');
        if (addBtn) { addBtn.textContent = match.available ? ('Add to bag · ' + money(match.price)) : 'Sold out'; addBtn.disabled = !match.available; }
        // swap gallery to the selected colour's image
        var swapped = false;
        var fi = match.featured_image || (match.featured_media && match.featured_media.preview_image);
        var fsrc = fi ? (fi.src || (fi.preview_image && fi.preview_image.src)) : null;
        if (fsrc && media()) {
          var base = fsrc.split('?')[0].replace(/_\d+x(\.[a-z]+)$/i, '$1');
          setMainImg(fsrc.indexOf('_') > -1 ? fsrc : base.replace(/(\.[a-z]+)$/i, '_1200x$1'));
          swapped = true;
          // highlight the matching thumb if present, else clear
          var hit = false;
          $$('[data-thumb]').forEach(function (x) {
            var xb = (x.getAttribute('data-full') || '').split('?')[0].replace(/_\d+x(\.[a-z]+)$/i, '$1');
            var on = xb && xb === base;
            x.classList.toggle('active', on);
            if (on) hit = true;
          });
          if (!hit) $$('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        }
        if (!swapped) {
          // fallback: match colour term against thumbnail alt text
          var term = (selected[0] || '').toLowerCase();
          if (term) {
            var thumbs = $$('[data-thumb]');
            for (var ti = 0; ti < thumbs.length; ti++) {
              var a = (thumbs[ti].getAttribute('data-alt') || '').toLowerCase();
              if (a.indexOf(term) > -1) {
                setMainImg(thumbs[ti].getAttribute('data-full'));
                thumbs.forEach(function (x) { x.classList.remove('active'); });
                thumbs[ti].classList.add('active');
                break;
              }
            }
          }
        }
        var lbl = $('[data-colour-label]'); if (lbl && selected[0]) lbl.textContent = selected[0];
      }
    }
    function reconcile(gi, val) {
      selected[gi] = val;
      var exact = variants.find(function (v) { return (v.options || []).every(function (o, i) { return selected[i] === o; }); });
      if (!exact) {
        var cand = variants.filter(function (v) { return (v.options || [])[gi] === val; });
        var pick = cand.filter(function (v) { return v.available; })[0] || cand[0];
        if (pick) (pick.options || []).forEach(function (o, i) { selected[i] = o; });
      }
    }
    $$('[data-opt-group]').forEach(function (g) {
      var gi = parseInt(g.getAttribute('data-opt-group'), 10);
      $$('.sw', g).forEach(function (b) {
        b.addEventListener('click', function () { reconcile(gi, b.getAttribute('data-opt-value')); update(); });
      });
    });
    update();
  }

  /* ---------- PDP gallery thumbs ---------- */
  $$('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      setMainImg(t.getAttribute('data-full'));
      $$('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  // keep header count in sync on load
  refreshCart();
})();
